export default [
  {
    path: '/b2bhub/NotaFiscal',
    name: 'notaFiscal',
    component: () => import('@/views/app/PTC/NotaFiscal/viewNotaFiscal.vue'),
    meta: {
      pageTitle: 'Notas Fiscais',
      action: 'read',
      resource: 'Acesso_NotaFiscal',
    },

  },
  {
    path: '/b2bhub/NotaFiscal/OcorrenciasTransporte',
    name: 'ocorrenciasTransporte',
    component: () => import('@/views/app/PTC/NotaFiscal/viewOcorrenciasTransporte.vue'),
    meta: {
      pageTitle: 'Ocorrências de Transporte',
      action: 'read',
      resource: 'Acesso_NotaFiscal',
      breadcrumb: [
        {
          text: 'Notas Fiscais',
          to: '/b2bhub/NotaFiscal',
        },
        {
          text: 'Ocorrências de Transporte',
          active: true,
        },
      ],
    },

  },
];
